import React from 'react';
import LogoImage from '../../../assests/favicon-logo.png';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center space-x-3 cursor-pointer group">
      <img  
        src={LogoImage} 
        alt="CVMatch Swiss" 
        className="h-12 w-auto group-hover:scale-105 transition-transform duration-300"
      />
    </div>
  );
};

export default Logo;